<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button type="primary" size="medium" @click="addButton(0)" v-if="userPermissions.indexOf('user_create') != -1">添加</el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="姓名">
              <el-input v-model="searchCondition.fullname" placeholder="请输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="searchCondition.mobile" placeholder="请输入手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable ref="apeTable" :data="userList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
          <el-table-column
            slot="second-column"
            align="left"
            width="150"
            label="ID">
            <template slot-scope="scope">
              <div>
                {{scope.row.id}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="手机号">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="top">
                <div>{{ scope.row.mobile }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="姓名">
            <template slot-scope="scope">
              <div>{{ scope.row.fullname }}</div>
            </template>
          </el-table-column>

          <!-- <el-table-column
            slot="second-column"
            align="center"
            label="状态">
            <template slot-scope="scope">
              <div>
                {{scope.row.status | UserStatus}}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            slot="second-column"
            align="center"
            label="角色">
            <template slot-scope="scope">
              <div>
                {{scope.row.user_roles | UserRoles}}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            slot="second-column"
            align="center"
            label="备注">
            <template slot-scope="scope">
              <div>
                {{ scope.row.description }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            slot="second-column"
            align="center"
            label="创建时间">
            <template slot-scope="scope">
              <div>
                {{scope.row.created_at }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="buttonType=='text'"
            align="center"
            label="操作">
            <template slot-scope="scope" v-if="scope.row.user_roles.length!=0">
              <span v-if="scope.row.user_roles[0].name!='admin'">
                <el-button size="mini" @click="bindCompany(scope.row.id, scope.row.fullname)" v-if="userPermissions.indexOf('user_company') != -1">公司绑定</el-button>
                <el-button size="mini" @click="detailButton(scope.row.id)">详情</el-button>
                <el-button size="mini" @click="editButton(scope.row.id)" v-if="userPermissions.indexOf('user_edit') != -1">编辑</el-button>
                <el-popover
                  v-if="userPermissions.indexOf('user_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini" >删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="userForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="formData.mobile" @input="event_inputMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="姓名" prop="fullname">
                <el-input v-model="formData.fullname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="角色绑定" prop="user_roles">
                <el-select v-model="formData.user_roles" filterable clearable placeholder="请选择">
                  <el-option
                    v-for="item in rolesList"
                    :key="item.id"
                    :label="item.display_name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="isShow">
            <el-col :span="22">
              <el-form-item label="公司绑定：" prop="user_company">
                <el-select v-model="formData.user_company" placeholder="请选择" multiple filterable style="width: 100%">
                  <el-option
                    v-for="item in companyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          
        </el-form>
      </template>
    </ApeDrawer>
     <!-- 公司绑定 -->
    <ModalDialog :dialogData="companyDialogData" @dialogConfirm="companyHandleConfirm" @dialogClose="companyDialogClose">
      <template slot="content">
        <el-form :model="companyRuleForm" ref="companyRuleForm" :label-position="'right'" label-width="96px">
          <el-form-item label="公司绑定：" prop="user_company">
            <el-select v-model="companyRuleForm.user_company" placeholder="请选择" multiple filterable style="width: 100%">
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ModalDialog from '@/components/ModalDialog'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ModalDialog
  },
  watch: {
    "companyRuleForm.user_company": function(val) {
      if(val) {
        this.companyDialogData.loading = false
      }else {
        this.companyDialogData.loading = true
      }
    }
  },
  data() {
    return {
      isShow: false,
      companyList: [],//用户绑定公司
      companyDialogData: {//审核模态框
        visible: false,
        title: '',
        width: '25%',
        loading: true,
        modal: false
      },
      companyRuleForm: {
        user_company: [],
        id: ''
      },
      userId: '',
      // 搜索条件
      searchCondition:{},
      loadingStaus: true,
      columns: [],
      // 表格列表数据
      userList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        user_roles: '',
      },
      // 表单验证
      rules: {
        mobile: [
          {required: true, message: '输入手机号', trigger: 'blur' },
          { min: 11,max:11, message: '请输入11位手机号' }
        ],
        fullname: [
          {required: true, message: '输入姓名', trigger: 'blur' },
        ],
        user_roles: [
          {required: true, message: '请选择角色', trigger: 'blur' },
        ],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        title: '权限绑定',
        width_height: '480px',
        btnLoading: false
      },
      // 用户绑定角色
      rolesList: [],
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
	event_inputMobile(){
		this.formData.mobile = this.formData.mobile.replace(/[^\d]/g,'')
	},
    //获取全部公司
    async getCompanyCategoryList() {
      let result = await this.$api.getCompanyCategoryList()
      if(result) {
        this.companyList = result
      }
    },
    //公司绑定
    bindCompany(id, fullname) {
		// console.log(user_roles)
		// let aaa = user_roles
		// let isadmin = '';
		// console.log(isadmin)
		// aaa.forEach((item)=>{
		// 	// console.log(item.name)
  //          isadmin = item.name
		// })
		// this.isadmin=isadmin
		// console.log(this.isadmin)
      this.companyDialogData.title = `公司绑定（ID${id})-${fullname}`
      this.companyRuleForm.id = id
      this.companyDialogData.visible = true
      this.getCompanyCategoryList()
      //获取用户绑定的公司
      this.viewUser(id)
    },
    //公司绑定确定事件
    companyHandleConfirm() {
      this.submitBindCompany()
    },
    //公司绑定提交事件
    async submitBindCompany () {
      if(this.companyRuleForm.user_company) {
        var companyArgs = {
          user_company: this.companyRuleForm.user_company
        } 
      }
      let result = await this.$api.bindCompany(this.companyRuleForm.id, companyArgs)
      if(result) { 
        this.$message.success("公司绑定成功")
        this.companyDialogData.visible = false
        this.$refs['companyRuleForm'].resetFields()
      }
    },
    //公司绑定取消事件
    companyDialogClose() {
      this.companyDialogData.visible = false
      this.$refs['companyRuleForm'].resetFields()
    },
    // 搜索
    searchButton() {
      this.initUserList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initUserList()
    },
    // 响应添加按钮
    async addButton() {
      this.isShow = false
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '添加用户'
      //角色列表
      this.getRolesList()
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    //用户详情
    async viewUser(id) {
      let result = await this.$api.viewUser(id)
      console.log(result,'详情')
      if (result) {
        let info = result
        let role = info.user_roles.length ? info.user_roles.shift() : {}
        info.user_roles = 'role_id' in role ? role.role_id : ''
        delete info.created_at
        delete info.tenant_id
        delete info.status
        // delete info.channel_account
        this.formData = info
        console.log(this.formData);
        this.companyRuleForm.user_company = info.user_company
      }
    },
    // 响应编辑按钮
    async editButton(id) {
      this.isShow = false
      this.userId = id
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.loading = false
      this.drawerData.visible = true
      this.drawerData.title = '编辑用户(UID：'+id+')'
      this.viewUser(id)
      this.getRolesList()
      this.drawerData.loading = false
    },
    //响应详情按钮
    detailButton(id) {
      this.isShow = true
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.loading = false
      this.drawerData.btnLoading = true
      this.drawerData.visible = true
      this.drawerData.title = '用户(UID：'+id+')'
      this.viewUser(id)
      this.getRolesList()
      this.getCompanyCategoryList()
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.btnLoading = false
      this.drawerData.loading = true
      this.rolesList = []
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          let postData = Object.assign({}, this.formData)
          console.log(postData);
          delete postData.channel_account
          postData.user_roles = postData.user_roles.split(',');
          if(this.userId) {
            delete postData.user_company
            this.updateUser(this.userId, postData)
          }else {
            this.createUser(postData)
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },

    //角色列表
    async getRolesList(){
      this.rolesList = await this.$api.getRolesList()
    },
    //编辑用户
    async updateUser(id, data) {
      await this.$api.updateUser(id, data)
      this.drawerData.visible = false
      this.drawerData.btnLoading = false
      this.$refs['userForm'].resetFields();
      this.$refs['userForm'].clearValidate();
      this.initUserList()
      this.initFormData()
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.$refs['userForm'].resetFields()
      })
    },
    //新增用户
    async createUser(data) {
      await this.$api.createUser(data)
      this.drawerData.visible = false
      this.drawerData.btnLoading = false
      this.$refs['userForm'].resetFields();
      this.$refs['userForm'].clearValidate();
      this.initUserList()
      this.initFormData()
      this.$nextTick(() => {
        this.$message.success('保存成功!')
      })
    },
    // 相应删除按钮
    async deleteButton(id) {
      let result = await this.$api.deleteUser(id)
      if(result) {
        this.initUserList()
      }
    },
    // 初始化用户列表
    async initUserList(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.searchCondition
      Object.assign(searchCondition,pagingInfo)
      let { data, pages}= await this.$api.getUserList(searchCondition)
      this.$nextTick(() => {
        this.userList = data
		
      })
      
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false

    }
  },
  mounted() {
    this.initUserList()
	
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .drag-handle
    font-size 24px
    cursor pointer
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .el-select > .el-input
    width 300px
  #generate {
    margin-bottom: -10px;
    margin-left: 4px;
  }
</style>
